/* "Pairs well with" scroll module (draft theme only; snippets/pdp-pairs.liquid, pdp-pairs/SPEC.md).
   Data: the theme's existing recommendations fetch - routes.product_recommendations_url?section_id&product_id&limit&intent,
   section rendering - first intent=complementary, then intent=related; the cards come from the block's own endpoint render
   ([data-pairs-src]). Both empty: the block is removed. Paging / dots / counter / arrows / keyboard / RTL: initPairs from
   pdp-pairs/REFERENCE.html. "+" (desktop): one variant -> the theme's AJAX add (window.xCartHelper.addItems, which
   re-renders the drawer and opens it via the cart event) and a check for 1.2s; several variants -> the theme's Quick View.
   Below 1024px the image / title open Quick View instead of the product page. */
(function () {
  if (window.__poPairs) return;
  window.__poPairs = true;
  var MOBILE = window.matchMedia('(max-width: 1023.98px)');
  var LIMIT = 10; // ask for the endpoint maximum; sold-out items and the current product are filtered server-side

  function fetchIntent(root, intent) {
    var url = root.getAttribute('data-url') + '?section_id=' + encodeURIComponent(root.getAttribute('data-section')) +
      '&product_id=' + encodeURIComponent(root.getAttribute('data-product')) + '&limit=' + LIMIT + '&intent=' + intent;
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('[data-pairs-src]');
      return src ? [].slice.call(src.children).filter(function (c) { return c.classList.contains('po-pair'); }) : [];
    });
  }

  function load(root) {
    if (root.__ppLoad) return; root.__ppLoad = true;
    fetchIntent(root, 'complementary').then(function (cards) {
      return cards.length ? cards : fetchIntent(root, 'related');
    }).then(function (cards) {
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 6;
      cards = cards.slice(0, limit);
      if (!cards.length) { root.remove(); return; }
      var track = root.querySelector('[data-track]');
      track.innerHTML = '';
      cards.forEach(function (c) { track.appendChild(document.importNode(c, true)); });
      root.classList.remove('is-loading');
      initPairs(root);
    }).catch(function () { root.remove(); });
  }

  /* production logic from REFERENCE.html: paging, dots, counter, arrows, keyboard, RTL */
  function initPairs(root) {
    var track = root.querySelector('[data-track]');
    var cards = [].slice.call(track.children).filter(function (c) { return !c.classList.contains('po-pair--spacer'); });
    var per = 2, pages = Math.ceil(cards.length / per);
    var dotsEl = root.querySelector('[data-dots]'), counter = root.querySelector('[data-count]');
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    var tpl = root.getAttribute('data-tpl') || '%r of %t';
    if (cards.length <= per) { root.classList.add('is-static'); return; }
    if (cards.length % per) { // odd count: an empty spacer so the last page starts on its own card
      var sp = document.createElement('div'); sp.className = 'po-pair po-pair--spacer'; sp.setAttribute('aria-hidden', 'true'); track.appendChild(sp);
    }
    var h = ''; for (var i = 0; i < pages; i++) h += '<span class="po-pairs__dot' + (i ? '' : ' is-on') + '"></span>';
    dotsEl.innerHTML = h;
    var gap = function () { var cs = getComputedStyle(track); return parseFloat(cs.columnGap || cs.gap) || 0; };
    var pageW = function () { return track.clientWidth + gap(); };
    var dir = function () { return getComputedStyle(root).direction === 'rtl' ? -1 : 1; };
    var reduced = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
    var page = 0;
    var go = function (p) { p = Math.max(0, Math.min(pages - 1, p)); track.scrollTo({ left: dir() * p * pageW(), behavior: reduced() ? 'auto' : 'smooth' }); };
    var sync = function () {
      page = Math.max(0, Math.min(pages - 1, Math.round(Math.abs(track.scrollLeft) / pageW())));
      dotsEl.querySelectorAll('.po-pairs__dot').forEach(function (d, i) { d.classList.toggle('is-on', i === page); });
      var a = page * per + 1, b = Math.min(cards.length, a + per - 1);
      var range = a === b ? String(a) : a + '–' + b;
      counter.textContent = tpl.replace('%r', range).replace('%t', cards.length);
      prev.disabled = page === 0; next.disabled = page === pages - 1;
      prev.setAttribute('aria-disabled', String(prev.disabled)); next.setAttribute('aria-disabled', String(next.disabled));
    };
    prev.addEventListener('click', function () { go(page - 1); });
    next.addEventListener('click', function () { go(page + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(page + dir()); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(page - dir()); }
    });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
    sync();
  }

  function quickView(id, url, el) {
    var qv = window.Alpine && window.Alpine.store && window.Alpine.store('xQuickView');
    if (qv && typeof qv.load === 'function') { qv.load(id, url, el); if (typeof qv.open === 'function') qv.open(); return true; }
    return false;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pdp-pairs] [data-pair-add], [data-pdp-pairs] [data-pair-open]');
    if (!t) return;
    if (t.hasAttribute('data-pair-open')) {
      if (!MOBILE.matches || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return; // desktop: normal link to the product
      if (quickView(t.getAttribute('data-product-id'), t.getAttribute('href'), t)) e.preventDefault();
      return;
    }
    e.preventDefault();
    if (parseInt(t.getAttribute('data-variants'), 10) > 1) {
      if (!quickView(t.getAttribute('data-product-id'), t.getAttribute('data-url'), t)) location.href = t.getAttribute('data-url');
      return;
    }
    var id = parseInt(t.getAttribute('data-variant-id'), 10);
    if (!id) return;
    var ev = (typeof CART_EVENT !== 'undefined' && CART_EVENT.cartUpdate) || null; // assets/constants.js (global const)
    if (window.xCartHelper && typeof window.xCartHelper.addItems === 'function' && ev) {
      var done = function () { document.removeEventListener(ev, done); t.classList.add('is-done'); setTimeout(function () { t.classList.remove('is-done'); }, 1200); };
      document.addEventListener(ev, done);
      window.xCartHelper.addItems([{ id: id, quantity: 1 }]);
    } else {
      location.href = t.getAttribute('data-url');
    }
  });

  function scan() { document.querySelectorAll('[data-pdp-pairs]').forEach(load); }
  document.addEventListener('shopify:section:load', function () { setTimeout(scan, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
